import React from "react";
import AddClothForm from "../../../views/settings/AddClothForm";
import { Modal } from "../../../core";
// import AddYarnQualityForm from "../../../views/settings/AddYarnQualityForm";

const AddYarnQuality = ({
  addClothQaulityModal,
  getClothQualities,
  closeModal,
}) => {
  return (
    <Modal
      closable={true}
      visible={addClothQaulityModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={() => closeModal("addClothQaulityModal")}
      tittle="Add Yarn Quality"
    >
      <AddClothForm
        getClothQualities={getClothQualities}
        closeModal={closeModal}
      />
    </Modal>
  );
};

export default AddYarnQuality;
